// Tiny Web Audio synth — no assets, works offline. Respects a mute flag.
let ctx;
const MUTE_KEY = "sfx_muted";

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    try {
      ctx = new (window.AudioContext || window.webkitAudioContext)();
    } catch {
      ctx = null;
    }
  }
  return ctx;
}

export function isMuted() {
  try {
    return localStorage.getItem(MUTE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setMuted(m) {
  try {
    localStorage.setItem(MUTE_KEY, m ? "1" : "0");
  } catch {
    /* noop */
  }
}

function tone(freq, start, dur, type = "sine", gain = 0.14) {
  const c = getCtx();
  if (!c) return;
  const t0 = c.currentTime + start;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  o.connect(g).connect(c.destination);
  o.start(t0);
  o.stop(t0 + dur + 0.03);
}

export function play(name) {
  if (isMuted()) return;
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  switch (name) {
    case "click": // fridge door latch
      tone(300, 0, 0.06, "square", 0.07);
      tone(150, 0.03, 0.09, "square", 0.05);
      break;
    case "whoosh": {
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(620, c.currentTime);
      o.frequency.exponentialRampToValueAtTime(130, c.currentTime + 0.5);
      g.gain.setValueAtTime(0.12, c.currentTime);
      g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.55);
      o.connect(g).connect(c.destination);
      o.start();
      o.stop(c.currentTime + 0.6);
      break;
    }
    case "flip":
      tone(420, 0, 0.05, "sine", 0.09);
      tone(640, 0.05, 0.06, "sine", 0.08);
      break;
    case "pop":
      tone(560, 0, 0.08, "sine", 0.11);
      break;
    case "tada":
      [523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.09, 0.35, "triangle", 0.13));
      break;
    default:
      break;
  }
}
